import { defineMessages } from 'react-intl'

const messages = defineMessages({
  layer1Title: {
    id: 'ContentHeader.layer1Title',
    description: '[Mantener HTML] Titulo de la cabecera del contenido de la capa 1',
    defaultMessage: 'Panel de indicadores de competitividad <small>actualizado a { lastUpdated }</small>'
  },
  layer1Subtitle: {
    id: 'ContentHeader.layer1Subtitle',
    description: '[Mantener HTML] Subtitulo de la cabecera del contenido de la capa 1',
    defaultMessage:
			'El panel se organiza en <strong>cuatro dimensiones</strong> esenciales a la hora de identificar las claves de la competitividad al servicio del bienestar inclusivo y sostenible. Utiliza el <strong>mini mapa</strong> a la derecha para orientarte.'
  },
  layer2Title: {
    id: 'ContentHeader.layer2Title',
    description: '[Mantner HTML] Titulo de la cabecera del contenido de la capa 2',
    defaultMessage: '<span class="ork-u-default-text-color">{levelNumber}</span> {levelName} <small>actualizado a {lastUpdated}</small>'
  },
  layer2Subtitle: {
    id: 'ContentHeader.layer2Subtitle',
    description: '[Mantener HTML] Subtitulo de la cabecera del contenido de la capa2',
    defaultMessage:
			'El panel se organiza en <strong>cuatro niveles</strong> que determinan el desempeño competitivo. Conocer más sobre la <a href={methodologyLink}>metodología de elaboración del panel</a>.'
  },
  layer3Title: {
    id: 'ContentHeader.layer3Title',
    description: '[Mantener HTML] Titulo de la cabecera del contenido de la capa 3',
    defaultMessage: '{indicatorName} <small>actualizado a {indicatorLastUpdated}</small>'
  },
  knowMoreAboutMethodology: {
    id: 'ContentHeader.knowMoreAboutMethodology',
    description: '[Mantener HTML] Subtitulo de la cabecera del contenido de la capa 1',
    defaultMessage:
			'Conocer más sobre <a href={methodologyLink}>el marco y la metodología de elaboración del panel</a>.'
  },
  moreDataAvailableNote: {
    id: 'ContentHeader.moreDataAvailableNote',
    description: '[Mantener HTML] Subtitulo de la cabecera del contenido de la capa 1',
    defaultMessage:
			'(*) En caso de disponer de datos más recientes para la región se indica con un <sup>*</sup> junto al año de comparación.'
  },
  relatedDocuments: {
    id: 'ContentHeader.relatedDocuments',
    description: 'Texto del botón que abre los análisis relacionados',
    defaultMessage: 'Análisis relacionados'
  },
  unit: {
    id: 'ContentHeader.unit',
    description: 'Unidad',
    defaultMessage: 'Unidad'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Content/ContentHeader/messages.js